import React, { useEffect } from 'react';

const ZipCode = ({
  onMouseMove,
  onMouseLeave,
  setIsIframeLoaded,
  iframeRef,
}) => {
  
  useEffect(() => {
    return () => {
      setIsIframeLoaded(false);
    };
  }, []);

  const iframeLoadedHandler = () => {
    const zipCodeMap = iframeRef.current.contentWindow.document.getElementById(
      'Zip2020'
    );
    zipCodeMap.addEventListener('mousemove', onMouseMove);
    zipCodeMap.addEventListener('mouseleave', onMouseLeave);
    setIsIframeLoaded(true);
  };

  return (
    <iframe
      className="USZipCodeMap"
      src="/zipcode.html"
      title="US Zipcode"
      width="820"
      height="570"
      onLoad={iframeLoadedHandler}
      ref={iframeRef}
      scrolling="no"
    />
  );
};

export default ZipCode;
